import React from 'react';

export default function NotFound({ title }) {
  return (
    <div className="container">
      <div className="not-found">
        <i>!</i>
        { title }
      </div>
    </div>
  );
}
